/**
 * 로그인 세션(`loginSession` / `store.state.userData`)의 `lngUserAdminID` 코드값.
 * 거래처(공급사) 포털 계정은 별도 UI·권한 처리 시 이 값과 비교한다.
 */
export const USER_ADMIN_ID_SUPPLIER_ACCOUNT = 60;
